import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { IDeviceInfoDTO } from '../../../../../../api/api';
import { useAuth } from '../../../../../../auth/auth-provider';
import { localized } from '../../../../../../i18n/i18n';
import { selectDataDumpData } from '../../../../../../state/features/admin-device/admin-device-slice';
import { LargeFormSwitch } from '../../../form/large-form-switch';
import { SideBarStack } from '../../../side-bar-stack';
import { DataDumpDownload } from '../../debug-logging/data-dump-download';
import { EnableDebuggingButtons } from '../../debug-logging/enable-debugging-buttons';
import { AdminBackupFirmwareSetting } from './admin-backup-firmware-setting';
import { FirmwareUpdater } from '../firmware-updater';
import { GeneralUnitConfigRow } from '../general-unit-config-row';
import { AdminIconButtons } from './admin-icon-buttons';

interface Props {
  device: IDeviceInfoDTO;
}

export const AdminUnitSettings: FC<Props> = React.memo(({ device }) => {
  const { isGlobalAdmin } = useAuth();
  const dataDumpData = useSelector(selectDataDumpData);

  if (!isGlobalAdmin) return <></>;

  return (
    <>
      <SideBarStack>
        <FirmwareUpdater connectId={device.connectId} />
        <EnableDebuggingButtons connectId={device.connectId} />
        <GeneralUnitConfigRow description={localized('RebootDaily')} input={<LargeFormSwitch name="dailyReboot" />} />
        <AdminBackupFirmwareSetting connectId={device.connectId} />
        <AdminIconButtons device={device} />
      </SideBarStack>
      {dataDumpData !== undefined && <DataDumpDownload dataDumpData={dataDumpData} />}
    </>
  );
});
